/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Vector_MemoryInputs */

const en_svchip_vector_memory = /** @type {(inputs: Svchip_Vector_MemoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vector memory`)
};

const ar_svchip_vector_memory = /** @type {(inputs: Svchip_Vector_MemoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ذاكرة المتجهات`)
};

const bn_svchip_vector_memory = /** @type {(inputs: Svchip_Vector_MemoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ভেক্টর মেমোরি`)
};

const de_svchip_vector_memory = /** @type {(inputs: Svchip_Vector_MemoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vektorspeicher`)
};

const es_svchip_vector_memory = /** @type {(inputs: Svchip_Vector_MemoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memoria vectorial`)
};

const fr_svchip_vector_memory = /** @type {(inputs: Svchip_Vector_MemoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mémoire vectorielle`)
};

const pt_svchip_vector_memory = /** @type {(inputs: Svchip_Vector_MemoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memória vetorial`)
};

const zh_svchip_vector_memory = /** @type {(inputs: Svchip_Vector_MemoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`向量内存`)
};

const tr_svchip_vector_memory = /** @type {(inputs: Svchip_Vector_MemoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vektör belleği`)
};

const ru_svchip_vector_memory = /** @type {(inputs: Svchip_Vector_MemoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Векторная память`)
};

const pl_svchip_vector_memory = /** @type {(inputs: Svchip_Vector_MemoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pamięć wektorowa`)
};

/**
* | output |
* | --- |
* | "Vector memory" |
*
* @param {Svchip_Vector_MemoryInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_vector_memory = /** @type {((inputs?: Svchip_Vector_MemoryInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Vector_MemoryInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_vector_memory(inputs)
	if (locale === "bn") return bn_svchip_vector_memory(inputs)
	if (locale === "de") return de_svchip_vector_memory(inputs)
	if (locale === "es") return es_svchip_vector_memory(inputs)
	if (locale === "fr") return fr_svchip_vector_memory(inputs)
	if (locale === "pt") return pt_svchip_vector_memory(inputs)
	if (locale === "zh") return zh_svchip_vector_memory(inputs)
	if (locale === "tr") return tr_svchip_vector_memory(inputs)
	if (locale === "ru") return ru_svchip_vector_memory(inputs)
	if (locale === "pl") return pl_svchip_vector_memory(inputs)
	return en_svchip_vector_memory(inputs)
});